export default __webpack_public_path__ + "locales/si/DeleteDialog.json?hash=eeb2be6c39852f73df7f9c7c164066ee";